import { ZodError, z } from "zod"

const EnvSchema = z.object({
  VITE_NODE_ENV: z.string().default("development"),
  VITE_API_URL: z.string().url().default("http://localhost:8080"),
  VITE_MARKETPLACE_URL: z.string().url(),
  VITE_FIREBASE_API_KEY: z.string(),
  VITE_FIREBASE_AUTH_DOMAIN: z.string(),
  VITE_FIREBASE_PROJECT_ID: z.string(),
  VITE_FIREBASE_STORAGE_BUCKET: z.string(),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string(),
  VITE_FIREBASE_APP_ID: z.string(),
  VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID: z.string(),
  VITE_MAPBOX_ACCESS_TOKEN: z.string(),
  VITE_GOOGLE_PLACES_API_KEY: z.string(),
  VITE_FIREBASE_AUTH_EMULATOR_HOST: z.string().optional(),
})

type Env = z.infer<typeof EnvSchema>

let env: Env

try {
  env = EnvSchema.parse(import.meta.env)
} catch (e) {
  const error = e as ZodError
  console.error("❌ Invalid ENV:")
  console.error(error.flatten().fieldErrors)
  process.exit(1)
}

export default env
